import { history } from '../../history';
// Interfaces
import { ISystemError } from '../../interfaces/systemerror.interfaces';
import { IErrorCodeOptions, IMiddlewareOptions } from './interfaces';
// Enums
import { ErrorContext } from '../../enums';

export const isResponseStatusHandled = (response: Response, errorCodeOptions?: IErrorCodeOptions): boolean =>
    errorCodeOptions?.errorCodesHandled?.includes(response.status);

export const redirectToSystemError = (response: Response, errorCodeNotFound: number): void => {
    history.replace('/systemerror', {
        error: !errorCodeNotFound ? response.status : `${response.status} (${errorCodeNotFound})`,
        errorMessage: response.headers.get('x-transaction-id'),
    } as ISystemError);
};

export const getHeaders = (options?: object, isFormData = false): Record<string, string> => {
    const headers = options ? { ...options } : {};

    if (!isFormData) {
        // default values
        headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }

    return headers;
};

export const getMiddlewareOptionsWithContext = (errorContext: ErrorContext): IMiddlewareOptions => ({
    errorCodeOptions: { errorCodeComponentContext: errorContext, errorCodesHandled: [] },
    noCredentials: false,
});

export const getEncondingFormat = (file: File): string => {
    // These conditions are implemented because we are not getting filetype for .ddd, .dta, .ical, .sav fileFormats
    // from input tag we are manually adding the encoding Formate for these file formats

    const fileName = file.name.split('.').pop().toLowerCase();

    if (fileName == 'ddd') {
        return 'application/vnd.fujixerox.ddd';
    } else if (fileName == 'dta') {
        return 'application/x-stata-dta';
    } else if (fileName == 'ical') {
        return 'text/calendar';
    } else if (fileName == 'sav') {
        return 'application/x-spss-sav';
    }
    //For other valid FileTypes
    return file.type;
};
